/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  rootUrl: string = 'https://localhost:7185/';
}

/**
 * Parameters for `provideApi.forRoot()`
 */
export interface ApiConfigurationParams {
  rootUrl?: string;
}
